/**
 *
 * ItemPageDescriptionContainer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    width: '100%',
    padding: 4,
    '& span': theme.typography.body1,
    '& p': theme.typography.body1,
  },
});

function ItemPageDescriptionContainer(props) {
  const { classes, children } = props;
  return <div className={classes.root}>{children}</div>;
}

ItemPageDescriptionContainer.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export default withStyles(styles)(ItemPageDescriptionContainer);
